// Extract validation logic into a reusable function
const validateCart = async (cart) => {
  console.log("Validating cart:", cart);
  const GLASS_JAR_HANDLE = "frische-menue-huhn-mit-reis-im-glas";
  const IS_FROZEN_METAFIELD = "custom.isfrozen";
  let jarCount400g = 0; // Count for 400g variant
  let jarCount800g = 0; // Count for 800g variant
  let frozenCount = 0;

// Validate cart rules
for (const item of cart.items) {
  const isJarProduct =
    item.title?.includes("(im Glas)") ||
    item.product_title?.includes("(im Glas)");

  const isFrozenProduct =
    item.title?.includes("gefroren") ||
    item.product_title?.includes("gefroren");

  if (isJarProduct) {
    const variantTitle = item.variant_title;

    // Gläser mit Varianten
    if (variantTitle === "400g") {
      jarCount400g += item.quantity;
    } else if (variantTitle === "800g") {
      jarCount800g += item.quantity;
    }
    // Gläser OHNE Varianten (z. B. Default Title / null)
    else {
      jarCount400g += item.quantity; // fallback
    }
  }

  if (isFrozenProduct) {
    frozenCount += item.quantity;
  }
}



  // Prepare messages and validate rules
  const messages = [];
  let disableCheckout = false;

  // Rule 1: Validate multiples of 6 for Frische Menüs im Glas (400g variant)
  if (jarCount400g > 0 && jarCount400g % 6 !== 0) {
    // const shortfall = 6 - (jarCount400g % 6);
    messages.push(
      `Die Mindestbestellmenge für unsere Frische Menüs im Glas beträgt 6 Stück. Du kannst diese in weiteren 6er Schritten (12, 18, 24, ...) bestellen.`,
      // `You must purchase Frische Menüs im Glas (400g) in multiples of 6. You currently have ${jarCount400g}. Add ${shortfall} more to meet the rule.`
    );
    disableCheckout = true;
  }

  // Rule 2: Validate multiples of 6 for Frische Menüs im Glas (800g variant)
  if (jarCount800g > 0 && jarCount800g % 6 !== 0) {
    // const shortfall = 6 - (jarCount800g % 6);
    messages.push(
      `Die Mindestbestellmenge für unsere Frische Menüs im Glas (800g) beträgt 6 Stück. Du kannst diese in weiteren 6er Schritten (12, 18, 24, ...) bestellen. Selbstverständlich sind die verschiedenen Sorten miteinander kombinierbar.`,
      // `You must purchase Frische Menüs im Glas (800g) in multiples of 6. You currently have ${jarCount800g}. Add ${shortfall} more to meet the rule.`,
    );
    disableCheckout = true;
  }

  // Rule 3: Validate minimum 12 frozen items
  if (frozenCount > 0 && frozenCount < 12) {
    // const shortfall = 12 - frozenCount;
    messages.push(
      `Aufgrund des Eigenkühl-Effekts beträgt die Mindestbestellmenge unserer gefrorenen Frische Menüs 12 Stück.`,
      // `You must purchase at least 10 Frische Menüs (frozen). You currently have ${frozenCount}. Add ${shortfall} more to meet the rule.`,
    );
    disableCheckout = true;
  }

  return { messages, disableCheckout };
};

// Function to update the UI
const updateUI = (messages, disableCheckout) => {
  // Display messages
  const feedbackContainer = document.getElementById("cart-feedback");
  if (feedbackContainer) {
    feedbackContainer.innerHTML = "";
    if (messages.length > 0) {
      messages.forEach((message) => {
        const errorDiv = document.createElement("div");
        errorDiv.classList.add("alert", "alert-danger");
        errorDiv.textContent = message;
        feedbackContainer.appendChild(errorDiv);
      });
    }
  }

  // Disable checkout button if validation fails
  const checkoutButton = document.querySelector('[name="checkout"]');
  if (checkoutButton) {
    checkoutButton.disabled = disableCheckout;
  }

  if (messages.length > 0) {
    // add hidden class to cart-feedback if checkout button is disabled
    feedbackContainer.classList.remove("hidden");
  } else {
    // remove hidden class to cart-feedback if checkout button is enabled
    feedbackContainer.classList.add("hidden");
  }
};

// Function to fetch cart data and validate it
const fetchAndValidateCart = async () => {
  try {
    const response = await fetch("/cart.js");
    if (response.ok) {
      const cart = await response.json();
      const { messages, disableCheckout } = await validateCart(cart);
      updateUI(messages, disableCheckout);
    } else {
      console.error("Failed to fetch cart data:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching cart data:", error);
  }
};

// Subscribe to cart update events
MinimogEvents.subscribe("ON_CART_UPDATE", async (cart) => {
  const { messages, disableCheckout } = await validateCart(cart);
  updateUI(messages, disableCheckout);
});

// Function to initialize the drawer observer
const initializeDrawerObserver = () => {
  // Select the drawer element
  const drawerElement = document.querySelector(".scd__wrapper");

  if (drawerElement) {
    // Create a MutationObserver to watch for changes
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          // Check if the drawer is open or closed
          if (drawerElement.classList.contains("hidden")) {
            console.log("Drawer is closed");
            // Perform your custom logic for when the drawer is closed
          } else {
            console.log("Drawer is opened");
            // Fetch and validate the cart when the drawer is opened
            fetchAndValidateCart();
          }
        }
      });
    });

    // Start observing the drawer element for attribute changes
    observer.observe(drawerElement, {
      attributes: true, // Configure it to listen to attribute changes
    });
  } else {
    console.error("Drawer element not found");
  }
};

function initializeScript() {
  initializeDrawerObserver();
  
  // Set up a polling function that periodically checks if the cart drawer exists
  setInterval(() => {
    const drawerElement = document.querySelector(".scd__wrapper");
    if (drawerElement && !drawerElement._hasObserver) {
      drawerElement._hasObserver = true;
      initializeDrawerObserver();
    }
  }, 1000); // Check every second
}

// Initialize the script when the DOM is loaded
document.addEventListener("DOMContentLoaded", initializeScript);

// Also try to initialize on Shopify events
document.addEventListener('page:load', initializeScript);
document.addEventListener('shopify:section:load', initializeScript);


// If the drawer is dynamically added to the DOM, use a MutationObserver to detect when it's added
const dynamicDrawerObserver = new MutationObserver(
  (mutationsList, observer) => {
    const drawerElement = document.querySelector(".scd__wrapper");
    if (drawerElement) {
      initializeDrawerObserver();
      // observer.disconnect(); // Stop observing once the drawer is found
    }
  },
);

// Start observing the document body for changes
dynamicDrawerObserver.observe(document.body, {
  childList: true,
  subtree: true,
});
